<div class="container-fluid" id="main">
  <!--<div class="jumbotron" style="margin-top: 38px;">-->
  <mat-card style="margin-top: 38px;" [class.mat-elevation-z10]='true'>
    <h1 style="margin-top: 21px;">
      Welcome
    </h1>

    @if (!legacyConversion) {
      <form [formGroup]="loginForm">
        <p style="margin-top: 32px;">Please login to view your retrofit applications.</p>
        <div>
          <mat-form-field style="width: 350px; max-width:100%" appearance="outline">
            <mat-label>Email Address</mat-label>
            <input
              matInput
              id="email"
              name="email"
              autocomplete="off"
              formControlName="email"
              placeholder="Enter email address"
              type="text"
              required trim="blur">
              @if (loginForm.get('email').hasError('required')) {
                <mat-error>Email Address is required</mat-error>
              }
              @if (loginForm.get('email').hasError('pattern')) {
                <mat-error>Invalid Email Address</mat-error>
              }
              @if (loginForm.get('email').hasError('maxLength')) {
                <mat-error>You have exceeded the maximum number of 100 characters.</mat-error>
              }
            </mat-form-field>
          </div>
          @if (recaptchaEnabled) {
            <div style="margin-top: 12px;">
              @if (recaptchaEnabled) {
                <re-captcha
                  #captchaRef
                  [siteKey]="siteKey"
                  (resolved)="onCaptchaResolved($event)"
                  (expired)="onCaptchaExpired()">
                </re-captcha>
              }
            </div>
          }
          <br>
            @if (loginError === 'reCAPTCHA verification failed') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
              <br /><br />We noticed unusual activity. Please refresh the page or try again in a moment.      </div>
            }
            <button style="margin-top: 18px;"
              mat-raised-button color="primary"
              (click)="logInUser()"
              [disabled]="!this.loginForm.valid">
              LOGIN
            </button>
          </form>
        }
        @if (legacyConversion) {
          <form [formGroup]="loginLegacyForm">
            <h4>Account Upgrade Needed</h4>
            <p style="margin-top: 21px;">Your account needs to be upgraded from our old system. This will require a one time upgrade process.
            Enter your password below. Once verified you will be asked to login one final time.</p>
            <div>
              <mat-form-field style="width: 300px; max-width:100%" appearance="outline">
                <mat-label>Email Address</mat-label>
                <input
                  matInput
                  id="email"
                  name="email"
                  formControlName="email"
                  type="text" >
                  @if (loginForm.get('email').hasError('required')) {
                    <mat-error>Email Address is required</mat-error>
                  }
                  @if (loginForm.get('email').hasError('pattern')) {
                    <mat-error>Invalid Email Address</mat-error>
                  }
                  @if (loginForm.get('email').hasError('maxLength')) {
                    <mat-error>You have exceeded the maximum number of 100 characters.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field style="width: 300px; max-width:100%" appearance="outline">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    id="password"
                    name="password"
                    formControlName="password"
                    placeholder="Enter password"
                    type="password"
                    required>
                    @if (loginLegacyForm.get('password').hasError('required')) {
                      <mat-error>Password is required</mat-error>
                    }
                    @if (loginLegacyForm.get('password').hasError('maxLength')) {
                      <mat-error>You have exceeded the maximum number of 100 characters.</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-md-12 caption-text">
                  <a (click)="legacyForgotPassword()" href="javascript:void(0)">
                    Forgot your password?
                  </a><br /><br />
                </div>
                <button mat-button (click)="cancelLegacylogInUser()">
                  CANCEL
                </button>&nbsp;
                <button mat-raised-button color="primary" (click)="legacyLogInUser()" [disabled]="!this.loginLegacyForm.valid">
                  UPGRADE
                </button>
              </form>
            }
            @if (this.legacyConvertSuccess) {
              <div>
                <div class="col-md-12 accent-text">
                  Your account was verified. You will be redirected in {{this.loginRedirectCount}} to login and finish the process.
                </div>
              </div>
            }
            @if (this.legacyForgotSuccess) {
              <div>
                <div class="col-md-12 accent-text">
                  You will be redirected in {{this.loginRedirectCount}} to complete the reset process.
                </div>
              </div>
            }
            @if (this.debarred) {
              <div>
                <div class="col-md-12 warn-text">
                  <br /><br />Please contact EBB customer service team for further assistance at (877) 232-4300 or <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
                </div>
              </div>
            }
            @if (loginError === 'not verified') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
                <br /><br />Your account cannot be verified. If you don't recall your login credentials, <a (click)="activateAccount($event)" href>please verify your account</a>
                or contact Customer Service for assistance at 877-232-4300 or at <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
              </div>
            }
            @if (loginError === 'no b2c but verified') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
                <br /><br />Your account appears to have a known error in creating the account password.
                In 10 seconds you will be transferred to the forgot password page to resolve this issue or <a (click)='forgotPasswordPageRedirect(loginForm.get("email").value)'>click here</a>.
              </div>
            }
            @if (loginError === 'no account') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
                <br /><br />Your account cannot be verified. If you don't recall your login credentials,
                please contact Customer Service for assistance at 877-232-4300 or at <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
              </div>
            }
            @if (loginError === 'not able to verify') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
                <br /><br />We were not able to verify your email and password combination. Please review your entries and make corrections or
                contact Customer Service for assistance at 877-232-4300 or at <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
              </div>
            }
            @if (loginError === 'not able to forget password') {
              <div class="col-md-12 warn-text" style="max-width:600px;">
                <br /><br />We were not able to upgrade your account. We do not see the email you entered in our system. Please check to make sure you entered it correctly.
                If you get this message again, contact Customer Service for assistance at 877-232-4300 or at <a href="mailto:info@crmp.org">info&#64;crmp.org</a>.
              </div>
            }      
        </mat-card>
        <div style="height: 150px;"></div>
      </div>
